import FlowDetail from '@/components/Flow/Flow.detail';
import { Collections, routingServerAndClientSide } from '@/utils';
import { fetchCourses } from '@/apis/requests/course';
import { COURSE_TYPES } from '@/constants';
import { SubPageLayout } from '@/layouts';
import { useEffect, useState } from 'react';

const FlowDetailPage = ({ type, collectionData }) => {
  const [collections, setCollections] = useState(null);
  useEffect(() => {
    setCollections(
      new Collections({
        collections: collectionData,
      })
    );
  }, [collectionData]);

  if (!collections) return;

  return <FlowDetail type={type} collections={collections} />;
};

FlowDetailPage.getInitialProps = async ({ res, query }) => {
  const { type } = query;
  try {
    if (!type || !COURSE_TYPES.includes(type)) {
      return routingServerAndClientSide({ res, path: '/notfound' });
    }

    const { data: collectionData } = await fetchCourses({ type });

    if (!collectionData?.data) {
      return routingServerAndClientSide({ res, path: '/notfound' });
    }
    return { type, collectionData: collectionData.data };
  } catch (error) {
    return routingServerAndClientSide({ res, path: '/notfound' });
  }
};

FlowDetailPage.getLayout = function getLayout(page) {
  return <SubPageLayout isBlack={false}>{page}</SubPageLayout>;
};

export default FlowDetailPage;
